import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import reducer from "./reducer";
import storage from "redux-persist/lib/storage";
//redux persit
import { persistStore, persistReducer } from "redux-persist"; //added

const persistConfig = {
  key: "root",
  storage,
};

//end

const middleware = [thunk];
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const initialState = {};
const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
  // other store enhancers if any
);

// const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

//const store = createStore(reducer, initialState, enhancer); //commet

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer, initialState, enhancer);
export const persistor = persistStore(store);

//export default store; // comment
